import Vue from 'vue'
import {
  mapGetters,
  mapActions
} from 'vuex'
import ApiClientsService from 'js/services/api/api-clients.js'
import ClientsService from 'js/services/api/clients.js'
import QrTokensService from 'js/services/api/qr-tokens.js'
import DocumentIdentifyTypeService from 'js/services/api/document_indentify_types.js'

import template from './index.pug'

const CC_DOCUMENT_TYPE = 3
const DNI_DOCUMENT_TYPE = 4
const NIE_DOCUMENT_TYPE = 5
const PASS_DOCUMENT_TYPE = 2
const DNI_REGEX = /^(\d{8})([A-Z])$/
const CC_REGEX = /^\d{6,9}$/
const LESS_THAN = 'less_than'
const letters = 'TRWAGMYFPDXBNJZSQVHLCKE'

Vue.component('everilion-register-form', {
  name: 'everilion-register-form',
  template: template(),
  data() {
    const vm = this

    return {
      web_title: Vue.store.state.webTitle,
      // Control del formulario
      step: 'rut_passport',
      documentType: undefined,
      rutPassport: '',
      rutPassportError: undefined,
      // Formulario 2A - Registro en Everilion
      registerForm: {
        Email: '',
        DocumentType: 1,
        RUTPassport: '',
        MunicipalityId: undefined,
        Name: '',
        SurName1: '',
        SurName2: '',
        Birthday: '',
        Address: '',
        PostalCode: '',
        Phone: '',
        SupportId: undefined,
        Accept: false
      },
      fieldsErrorsRegister: vm.resetFieldErrors(),
      errorRegister: undefined,
      datepickerConfig: {
        allowInput: true,
        formatDate(date) {
          return moment(date).format('DD/MM/YYYY')
        },
        parseDate(date) {
          return moment(date, 'DD/MM/YYYY').toDate()
        },
        disableMobile: true
      },
      conditions: false,
      // Formulario 2B - Código de TSC
      tscCode: '',
      errorsValidationTSC: undefined,
      documentIdentifyType: [],
      onlyNumbers: (oldValue, value) => {
        if (value === '') return ''
        if (value && String(value).trim().match(/^[0-9]*$/)) {
          return String(value).trim()
        }
        if (oldValue) {
          return String(oldValue).trim()
        }

        return ''
      },
      clientCode: null,
      idMediaProfile: null,
      supportId: null,
      apiKey: API_KEY
    }
  },
  computed: {
    ...mapGetters('municipality', ['availableMunicipalities']),
    hasCompensationCenter() {
      return this.administrativeArea && this.administrativeArea.compensation_center_id
    },

    documentTypeOptions() {
      return this.documentIdentifyType.map(documentType => ({
        label: this.$t(`everilionRegisterForm.rutPassport.documentIdentifyType.${documentType.code}`),
        value: documentType.code
      }))
    },

    qrInteroperableActive() {
      return !!this.administrativeArea?.config?.qr_interoperable_active
    },

    conditionsUrl() {
      const url = this.$t(`everilionRegisterForm.registerEverilion.conditionsUrls.${this.$currentAppConfig.code}`)
      return (url && !url.includes('everilionRegisterForm.registerEverilion.conditionsUrls')) ? url : null
    },

    isExternalConditions() {
      return this.qrInteroperableActive && !!this.conditionsUrl
    }
  },

  watch: {
    $currentAppConfig() {
      this.setDocumentType()
    }
  },
  created() {
    this.setDocumentType()
    this.getDocumentIdentifyTypes()
    //this.getApiKey()
  },
  methods: {
    ...mapActions(['escucharAudio']),
    async getDocumentIdentifyTypes() {
      const params = {
        per: 0,
        order_dir: 'asc',
        order_by: 'code'
      }
      const {
        data
      } = await DocumentIdentifyTypeService.index(params)
      if (this.$currentAppConfig.document_identify_type_ids) {
        this.documentIdentifyType = data.filter(docs => this.$currentAppConfig.document_identify_type_ids.includes(docs.id))
        this.documentType = this.documentIdentifyType[0].code
      } else {
        this.documentIdentifyType = []
      }
    },
    setDocumentType() {
      this.documentType = this.$currentAppConfig.default_document_type
    },
    subbmitRutPassport() {
      const vm = this
      this.rutPassportError = ''

      const errorTranslationBase = 'everilionRegisterForm.rutPassport.errors'

      // Eliminar posibles espacios en blanco
      if (this.rutPassport) {
        this.rutPassport = $.trim(this.rutPassport)
      }

      // Control de errores
      if (this.rutPassport === '') {
        this.rutPassportError = this.$t(`${errorTranslationBase}.emptyIdentifier`)
      } else if (this.documentType === CC_DOCUMENT_TYPE && !this.rutPassport.match(CC_REGEX)) {
        this.rutPassportError = this.$t(`${errorTranslationBase}.invalidCC`)
      } else if (this.documentType === DNI_DOCUMENT_TYPE && !vm.validDNI(this.rutPassport)) {
        this.rutPassportError = this.$t(`${errorTranslationBase}.invalidDNI`)
      } else if (this.documentType === NIE_DOCUMENT_TYPE && !vm.validarNIE(this.rutPassport)) {
        this.rutPassportError = this.$t(`${errorTranslationBase}.invalidNIE`)
      } else if (this.documentType === PASS_DOCUMENT_TYPE &&
        !vm.validarPasaporte(this.rutPassport)) {
        this.rutPassportError = this.$t(`${errorTranslationBase}.invalidPassport`)
      }

      if (this.rutPassportError) return

      vm.registerForm.RUTPassport = this.rutPassport
      vm.registerForm.DocumentType = vm.documentType
      vm.registerForm.Email = vm.$user.email

      const params = {
        administrative_area_id: this.administrativeArea.id,
        rut: this.rutPassport,
        document_type: this.documentType
      }

      ApiClientsService.existsAccount(params).then(() => {
        ApiClientsService.getClient(params).then(response => {
          // El cliente existe, se pasa a comprobar si tiene TSC activas
          // Si las tiene debe validar el número para que se le activen
          if (response.tsc) {
            this.step = 'tsc_form'
          } else {
            this.checkUser()
          }
          // Error de Everilion o no cliente
        }, response => {
          if (response.data == null || response.data === -2) {
            this.rutPassportError = this.$t(`${errorTranslationBase}.retry`)
            // El cliente no existe, se va al paso 2 del formulario
          } else {
            if (this.qrInteroperableActive) {
              this.createClientCode()
            } else {
              this.getQrToken()
            }

          }
        })
      }, response => {
        if (response.data && response.data.data && response.data.data.rut === 'taken') {
          this.rutPassportError = this.$t(`${errorTranslationBase}.identifierTaken`)
        }
      })
    },
    validarPasaporte(pasaporte) {
      // Expresión regular para validar que el pasaporte sea alfanumérico y hasta 15 caracteres
      const regularPassportExpression = /^[A-Za-z0-9]{1,15}$/

      // Verifica que el pasaporte tenga y números
      const containsNumbers = /[0-9]/.test(pasaporte)

      // Validar el formato general y asegurarse de que contiene tanto letras como números
      return regularPassportExpression.test(pasaporte) && containsNumbers
    },
    validateRegisterForm() {
      const vm = this

      let valid = true

      // No se han aceptado los términos de uso
      if (!vm.registerForm.Accept) {
        vm.fieldsErrorsRegister.Accept = vm.$t(
          'everilionRegisterForm.registerEverilion.errors.accept'
        )
        valid = false
        // Se han aceptado los términos de uso
      } else {
        const fieldsFilledByUser = [
          'Name', 'SurName1', 'Birthday', 'PostalCode', 'Phone'
        ]
        _.each(fieldsFilledByUser, field => {
          const typedValue = vm.registerForm[field]

          if (!typedValue || !$.trim(typedValue)) {
            vm.fieldsErrorsRegister[field] = vm.$t(
              'everilionRegisterForm.registerEverilion.errors.invalidField'
            )
            valid = false
          }
        })
      }

      return valid
    },

    registerEverilion() {
      const vm = this

      vm.errorRegister = undefined
      vm.fieldsErrorsRegister = vm.resetFieldErrors()

      if (vm.validateRegisterForm()) {
        const params = {
          administrative_area_id: vm.administrativeArea.id,
          client: JSON.parse(JSON.stringify(vm.registerForm))
        }

        // Convertimos la fecha al formato de Everilion
        params.client.Birthday = moment.utc(
          moment(vm.registerForm.Birthday).format('YYYY-MM-DD')
        ).valueOf()

        ApiClientsService.registerClient(params).then(() => {
          vm.$notifications.send({
            id: 'everilion-register-form-success',
            text: vm.$t('everilionRegisterForm.registerEverilion.success'),
            type: 'success',
            close: true
          })
          vm.$emit('reload-view')
        }, response => {
          this.fieldsErrorsRegister = response.data.errors
          const min_age_years = vm.administrativeArea.config.min_age_years
          if (response.data.errors.birthdate === LESS_THAN) {
            vm.fieldsErrorsRegister.Birthday = vm.$t(`everilionRegisterForm.registerEverilion.errors.birthdate.${response.data.errors.birthdate}`,
              { count: `${min_age_years}` })
          }
        })
      }
    },

    checkUser() {
      const vm = this

      ClientsService.get(vm.$user.id).then(response => {
        const clientAccount = response.client_accounts.find(
          account => account.administrative_area_id === vm.administrativeArea.id
        )

        // Si el usuario no tiene cuenta en el municipio se le manda a que indique su rut
        if (!clientAccount) {
          vm.step = 'rut_passport'
          // Si el usuario tiene cuenta se le recarga la vista
        } else {
          vm.$emit('reload-view')
        }
      })
    },

    /*
     * Obtiene un token QR nuevo del bakend y procede al fomulario de registro de Everilion
     */
    getQrToken() {
      const vm = this
      QrTokensService.get().then(response => {
        vm.registerForm.SupportId = response.token
        vm.registerForm.DocumentType = vm.documentType
        vm.registerForm.RUTPassport = vm.rutPassport
        vm.registerForm.Email = vm.$user.email
        vm.registerForm.MunicipalityId = vm.administrativeArea.code
        vm.step = 'register_form'
      })
    },

    validateTSCCode() {
      const vm = this
      vm.errorsValidationTSC = undefined

      const params = {
        administrative_area_id: vm.administrativeArea.id,
        rut: vm.rutPassport,
        tsc: vm.tscCode,
        document_type: vm.documentType
      }

      ApiClientsService.validateClientTSC(params).then(() => {
        vm.$notifications.send({
          id: 'everilion-validate-tsc-success',
          text: vm.$t('everilionRegisterForm.validateTsc.success'),
          type: 'success',
          close: true
        })
        vm.$emit('reload-view')
      }, () => {
        vm.errorsValidationTSC = vm.$t('everilionRegisterForm.validateTsc.error', {
          web_title: this.web_title
        })
      })
    },

    showConditions() {
      if (this.isExternalConditions) {
        window.open(this.conditionsUrl)
      } else {
        this.conditions = true
      }
    },

    closeConditions() {
      this.conditions = false
    },

    resetFieldErrors() {
      return {
        Name: undefined,
        SurName1: undefined,
        SurName2: undefined,
        Birthday: undefined,
        PostalCode: undefined,
        Address: undefined,
        Phone: undefined,
        Accept: undefined
      }
    },
    validarNIE(nie) {
      const expresionRegularNIE = /^[XYZ][0-9]{7}[A-Z]$/ // Expresión regular para NIE

      if (!expresionRegularNIE.test(nie)) {
        return false // Formato inválido
      }

      // Reemplazar la letra inicial por el número correspondiente
      const number = nie.replace(/^X/, '0').replace(/^Y/, '1').replace(/^Z/, '2')

      const letter = nie.charAt(8).toUpperCase() // La letra de control al final
      // Cálculo de la letra correcta
      const expectedLetter = letters[parseInt(number.substring(0, 8), 10) % 23]

      return letter === expectedLetter // Devuelve true si la letra coincide
    },
    validDNI(value) {
      // Normalized string for lowerCase letter chars
      const str = value.toString().toUpperCase()

      // Validation of format
      if (!DNI_REGEX.test(str)) return false

      // Validate if the letter correspond to the numbers
      const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET'
      const letter = str.substr(-1)
      const charIndex = parseInt(str.substr(0, 8)) % 23
      if (validChars.charAt(charIndex) === letter) return true

      return false
    },
    createClientCode() {
      ApiClientsService.createClientCode().then((response) => {
        this.clientCode = response.client_code
        this.mediaProfiles()
      }, () => {
        console.log("error")
      })
    },
    mediaProfiles() {
      if (this.administrativeArea?.media_profiles) {
        const mediaProfiles = this.administrativeArea.media_profiles.filter(x => x.code == "100")
        if (mediaProfiles.length != 0) {
          this.idMediaProfile = mediaProfiles[0].id
          this.getTitleByProfile()
        }
      }
    },
    getTitleByProfile() {
      const vm = this
      ApiClientsService.getTitleByProfile(this.idMediaProfile, vm.administrativeArea.id).then((data) => {
        if (data) {
          const params = {
            ClientCode: this.clientCode,
            Profile: 100,
            walletBalance: 0,
            ZoneAdmin: String(vm.administrativeArea.config?.car_map_config?.zone_admin),
            TNEExpiration: "07/07/2028",
            OwnerCode: parseInt(data.qr_token_owner_code) || 0,
            Issuer: parseInt(data.qr_token_issuer_code) || 0,
            SecurityConfiguration: parseInt(data.qr_token_security_configuration) || 0,
            ExpirationDate: parseInt(data.qr_token_expiration) || 0,
            GenerationType: 2,
            QrVersion: parseInt(data.qr_version) || 0,
            QrServiceType: parseInt(data.qr_interoperable_type) || 0,
          }
          this.createToken(params)
        }
      }, () => {
        console.log("error")
      })
    },
    createToken(params) {
      const vm = this
      const queryParams = {
        clientId: vm.administrativeArea.config?.car_map_config?.client_id,
        tokenType: 44,
        cardHardwareId: 23,
        technology: "technology",
        structureType: "json",
        dataType: "text",
        administrativeArea: vm.administrativeArea.id
      }
      ApiClientsService.createToken(params, queryParams, this.apiKey).then((response) => {
        this.supportId = response;
        vm.registerForm.SupportId = String(this.supportId).trim().padStart(8, '0')
        vm.registerForm.ClientCode = this.clientCode
        vm.registerForm.MunicipalityId = this.availableMunicipalities[0].code
        vm.step = 'register_form'
      }, () => {
        console.log("error")
      })
    },
    getApiKey() {
      ApiClientsService.getApiKey().then((response) => {
        this.apiKey = response.apiKey
      })
    }
  },
  mounted() {
    setTimeout(() => {
      const boton = document.getElementById('Identificarme')
      const left = this
      if (boton != null) {
        // Agregar un listener para el evento focus
        boton.addEventListener('focus', () => {
          const textListen = left.$t('everilionRegisterForm.rutPassport.mainButton')
          left.escucharAudio(textListen)
        })
      }
    }, 1000)
  }
})
